import { MusicNoteIdentity, NoteAccidental } from "../../wasm/pkg/wasm";
import { findNoteByHalfsteps, printNoteName, toNoteNameNoContext } from "../models/wasm.model";
import { AudioHistoryState } from "../statemachines/AudioHistoryState";
import { chooseSharpsFlatsGivenMinorRoot } from "./chooseSharpsFlatsGivenMinorRoot";

type TranscriptionPreviewNote = {
  minorTonicId: MusicNoteIdentity;
  minorTonicName: string;
  majorTonicName: string;
};
type TranscriptionPreviewEntry = {
  originalScaleId: string;
  original: TranscriptionPreviewNote;
  target: TranscriptionPreviewNote;
};
export type TranscriptionPreview = {
  entries: Array<TranscriptionPreviewEntry>;
};

function buildPreviewNotes(
  minorTonicId: MusicNoteIdentity,
  userSharpFlat: NoteAccidental,
  minorTonicName?: string
): TranscriptionPreviewNote {
  const sharpFlat = chooseSharpsFlatsGivenMinorRoot(minorTonicId, userSharpFlat);
  const majorTonicId = findNoteByHalfsteps(minorTonicId, 3);
  return {
    minorTonicId,
    minorTonicName: minorTonicName || toNoteNameNoContext(minorTonicId, sharpFlat),
    majorTonicName: toNoteNameNoContext(majorTonicId, sharpFlat),
  };
}

export function initBlankTranscriptionPreview(audioHistory: AudioHistoryState, scaleId: string): TranscriptionPreviewEntry {
  const minorTonicId = audioHistory.chordsInScales[scaleId].scale.family.minor_tonic_id;
  const minorTonicName = printNoteName(audioHistory.chordsInScales[scaleId].scale.family.notes[0].note_name); // relying on impl detail
  const sharpFlat = audioHistory.chordsInScales[scaleId].scale.family.scale_uses_sharps_or_flats;
  const original = buildPreviewNotes(minorTonicId, sharpFlat, minorTonicName);
  return {
    originalScaleId: scaleId,
    original,
    target: { ...original },
  };
}

export function buildTranscriptionPreview(
  old: TranscriptionPreview,
  howManyHalfSteps: number,
  targetSharpFlat: NoteAccidental
): TranscriptionPreview {
  const entries = old.entries.map((en) => {
    const minorTonicId = findNoteByHalfsteps(en.original.minorTonicId, howManyHalfSteps);
    return {
      ...en,
      target: buildPreviewNotes(minorTonicId, targetSharpFlat),
    };
  });
  return { entries };
}
